<template>
  <div class="row">
    <div class="col-12 row">
      <div class="col-8">
        <base-input class="text-left" label="Nome Fantasia/Razão Social: *">
          <el-input
            color="success"
            placeholder="Nome Fantasia/Razão Social"
            v-model="payload.razao_social"
            :class="erros.razao_social === true ? 'has-danger' : ''"
          >
          </el-input>
        </base-input>
      </div>
      <div class="col-4">
        <base-input class="text-left" label="CNPJ: *">
          <el-input
            :disabled="hasCpfCnpjValue"
            color="success"
            placeholder="Ex: 00.000.000/0000-00"
            v-model="payload.cpf_cnpj"
            v-mask="cpfCnpj"
            :class="erros.cpf_cnpj === true ? 'has-danger' : ''"
          >
          </el-input>
        </base-input>
      </div>
    </div>
    <div class="col-12 row">
      <div class="col-4">
        <base-input class="text-left" label="Endereço: *">
          <el-input
            color="success"
            placeholder="Ex: Avenida Getúlio Vargas"
            v-model="payload.endereco"
            :class="erros.endereco === true ? 'has-danger' : ''"
          >
          </el-input>
        </base-input>
      </div>
      <div class="col-4">
        <base-input class="text-left" label="Complemento: ">
          <el-input
            color="success"
            placeholder="Ex: Quadra D"
            v-model="payload.complemento"
          >
          </el-input>
        </base-input>
      </div>
      <div class="col-4">
        <base-input class="text-left" label="Bairro: *">
          <el-input
            color="success"
            placeholder="Ex: Centro"
            v-model="payload.bairro"
            :class="erros.bairro === true ? 'has-danger' : ''"
          >
          </el-input>
        </base-input>
      </div>
    </div>
    <div class="col-12 row">
      <div class="col-4">
        <base-input class="text-left" label="Cidade: *">
          <el-input
            color="success"
            placeholder="Ex: Manaus"
            v-model="payload.cidade"
            :class="erros.cidade === true ? 'has-danger' : ''"
          >
          </el-input>
        </base-input>
      </div>
      <div class="col-4">
        <base-input class="text-left" label="Estado: *">
          <el-input
            color="success"
            placeholder="Ex: AM"
            v-mask="'AA'"
            v-model="payload.estado"
            :class="erros.estado === true ? 'has-danger' : ''"
          >
          </el-input>
        </base-input>
      </div>
      <div class="col-4">
        <base-input class="text-left" label="CEP: *">
          <el-input
            color="success"
            placeholder="Ex: 00.000-000"
            v-model="payload.cep"
            v-mask="'##.###-###'"
            :class="erros.cep === true ? 'has-danger' : ''"
          >
          </el-input>
        </base-input>
      </div>
    </div>
    <div class="col-12 row">
      <div class="col-4">
        <base-input class="text-left" label="Inscrição Estadual:">
          <el-input
            color="success"
            v-model="payload.IE"
            placeholder="Inscrição Estadual"
          >
          </el-input>
        </base-input>
      </div>
      <div class="col-4">
        <base-input class="text-left" label="Inscrição Municipal:">
          <el-input
            color="success"
            v-model="payload.IM"
            placeholder="Inscrição Municipal"
          >
          </el-input>
        </base-input>
      </div>
      <div class="col-4">
        <base-input class="text-left" label="Local:">
          <el-input
            color="success"
            placeholder="Ex: Filial 2 ou Obra BR174"
            v-model="payload.local"
          >
          </el-input>
        </base-input>
      </div>
    </div>
    <div class="col-12 row">
      <div class="col-6">
        <base-input class="text-left" label="E-mail: *">
          <el-input
            color="success"
            placeholder="Ex: email@dominio.com"
            v-model="payload.email"
            :class="erros.email === true ? 'has-danger' : ''"
          >
          </el-input>
        </base-input>
      </div>
      <div class="col-6 text-left">
        <base-input label="Fuso Horário: *">
          <el-select
            class="select-success mb-3 pagination-select"
            placeholder="Fuso Horário"
            v-model="payload.fuso"
            :class="erros.fuso === true ? 'has-danger' : ''"
          >
            <el-option
              v-for="item in fusos"
              :key="item.id"
              class="select-success"
              :label="item.value"
              :value="item.id"
              >{{ item.value }}</el-option
            >
          </el-select>
        </base-input>
      </div>
    </div>
    <div class="col-12 row">
      <div class="col-6">
        <base-input class="text-left" label="Rótulo Extra 100%">
          <el-input
            color="success"
            placeholder="Ex: Extras 100%"
            v-model="payload.labelExtra100"
          >
          </el-input>
        </base-input>
      </div>
      <div class="col-6">
        <base-input class="text-left" label="Rótulo Extra 50%">
          <el-input
            color="success"
            placeholder="Ex: Extras 50%"
            v-model="payload.labelExtra50"
          >
          </el-input>
        </base-input>
      </div>
    </div>

    <div class="col-12 row">
      <div class="col-6">
        <base-input class="text-left" label="Latitude">
          <el-input
            color="success"
            placeholder="Latitude"
            v-model="payload.latitude"
          >
          </el-input>
        </base-input>
      </div>
      <div class="col-6">
        <base-input class="text-left" label="Longitude">
          <el-input
            color="success"
            placeholder="Longitude"
            v-model="payload.longitude"
          >
          </el-input>
        </base-input>
      </div>
    </div>

    <div class="col-12 row">
      <div class="offset-10 col-2">
        <base-button
          :disabled="isLoading"
          type="success"
          class="animation-on-hover"
          @click="salvar()"
          >{{ tipo === 1 ? `Cadastrar` : `Salvar` }}</base-button
        >
      </div>
    </div>
  </div>
</template>

<script>
/**
    Tipo 1: Cadastro de Postos
    Tipo 2: Edição de Postos
*/
import { BaseInput } from "../../components/index";
import { Select, Option } from "element-ui";

export default {
  name: "FormPostoTrabalho",
  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    BaseInput,
  },
  props: {
    tipo: "",
    posto: "",
    isLoading: false,
  },
  data() {
    return {
      fusos: [
        { id: "America/Noronha", value: "Fernando de Noronha (GMT-2)" },
        { id: "America/Sao_Paulo", value: "Brasília (GMT-3)" },
        { id: "America/Manaus", value: "Amazonas (GMT-4)" },
        { id: "America/Rio_Branco", value: "Acre (GMT-5)" },
      ],
      hasCpfCnpjValue: false,
      payload: {
        setDB: "",
        cpf_cnpj: "",
        tipo: "",
        razao_social: "",
        fantasia: "",
        endereco: "",
        complemento: "",
        bairro: "",
        cep: "",
        estado: "",
        cidade: "",
        IE: "",
        IM: "",
        telefone: "",
        email: "",
        usuario: "",
        senha: "",
        banco_de_dados: "",
        local: "",
        mobile: "",
        qrcode: "",
        qtde_postos: "",
        valor_vale_refeicao: "",
        valor_vale_transporte: "",
        carga_horaria: "",
        tolerancia: "",
        fuso: "America/Manaus",
        labelExtra100: "Extras 100%",
        labelExtra50: "Extras 50%",
        latitude: "",
        longitude: "",
      },
      erros: {
        razao_social: "",
        cpf_cnpj: "",
        endereco: "",
        bairro: "",
        cidade: "",
        estado: "",
        cep: "",
        email: "",
        fuso: "",
      },
    };
  },
  mounted() {
    if (this.tipo === 2) {
      this.payload = this.posto;
    }
    this.hasCpfCnpjValue = this.payload.cpf_cnpj !== "";
  },
  methods: {
    validarDados() {
      let status = true;
      if (!this.payload.razao_social || this.payload.razao_social === "") {
        status = false;
        this.erros.razao_social = true;
      } else this.erros.razao_social = false;

      if (!this.payload.cpf_cnpj || this.payload.cpf_cnpj === "") {
        status = false;
        this.erros.cpf_cnpj = true;
      } else if (
        this.payload.cpf_cnpj.length === 14 ||
        this.payload.cpf_cnpj.length === 18
      ) {
        this.erros.cpf_cnpj = false;
      } else {
        status = false;
        this.erros.cpf_cnpj = true;
      }

      if (!this.payload.endereco || this.payload.endereco === "") {
        status = false;
        this.erros.endereco = true;
      } else this.erros.endereco = false;

      if (!this.payload.bairro || this.payload.bairro === "") {
        status = false;
        this.erros.bairro = true;
      } else this.erros.bairro = false;

      if (!this.payload.cidade || this.payload.cidade === "") {
        status = false;
        this.erros.cidade = true;
      } else this.erros.cidade = false;

      if (!this.payload.estado || this.payload.estado === "") {
        status = false;
        this.erros.estado = true;
      } else this.erros.estado = false;

      if (!this.payload.cep || this.payload.cep === "") {
        status = false;
        this.erros.cep = true;
      } else this.erros.cep = false;

      if (!this.payload.email || this.payload.email === "") {
        status = false;
        this.erros.email = true;
      } else this.erros.email = false;

      return status;
    },
    salvar() {
      if (this.validarDados()) {
        //tratando dados
        this.payload.tipo = this.payload.cpf_cnpj.length <= 14 ? "F" : "J";
        this.payload.cpf_cnpj = this.payload.cpf_cnpj.replace(
          /[. - / - -]/g,
          ""
        );
        this.payload.fantasia = this.payload.razao_social;
        this.payload.cep = this.payload.cep.replace(/[. - / - -]/g, "");
        this.$emit("salvarPostoTrabalho", this.payload);
      }
    },
  },

  watch: {
    nome() {
      this.payload.razao_social = String(
        this.payload.razao_social
      ).toUpperCase();
    },
    email() {
      this.payload.email = String(this.payload.email).toLowerCase();
    },
  },

  computed: {
    cpfCnpj() {
      return this.payload.cpf_cnpj.length <= 14
        ? "###.###.###-##"
        : "##.###.###/####-##";
    },
    nome() {
      return this.payload.razao_social;
    },
    email() {
      return this.payload.email;
    },
  },
};
</script>
